<div class="modal-header">
  <button
    type="button"
    (click)="onClickClose()"
    class="close"
    aria-label="Close"
  >
    <span aria-hidden="true">&times;</span>
  </button>

  <h3 class="modal-title">
    <strong>{{ titulo }}!</strong>
  </h3>
</div>

<div class="modal-body text-center">
  <span class="icon warning icone-laranja"></span>
  <h4>Não identificamos o token de Validação de Segurança</h4>
  <h4>
    Se o celular do Cliente não for validado,
    <span class="text-danger"
      >não será permitido utilizar a Assinatura Digital do Contrato!</span
    >
  </h4>
  <h4>Deseja realmente continuar?</h4>
</div>

<div class="modal-footer">
  <button
    *ngIf="showFecharBtn"
    type="button"
    class="btn btn-border-orange"
    (click)="onClickClose()"
  >
    {{ labelFechar }}
  </button>

  <button
    *ngIf="showOkBtn"
    type="button"
    class="btn btn-full-orange"
    (click)="onClickOk()"
  >
    {{ labelOk }}
  </button>
</div>
